import * as Sentry from '@sentry/nextjs'
import { clearAuthToken } from '../../../../../utils/authUtils'
import { globalUserProxy } from '../../../../../proxies/globalUserProxy'
import { gtmTrackUserLogout } from '../../../../../utils/gtmUtils'
import { apiExecuteSignOut } from './apiExecuteSignOut'

export async function handleSignOut (): Promise<void> {
  const userId = globalUserProxy.user?.id
  gtmTrackUserLogout({ userId: String(userId) })
  Sentry.setUser(null)
  await apiExecuteSignOut()
  clearAuthToken()
  window.location.href = '/'
}

interface CriticalSignOutArgs {
  userId: number
  merchantId: string
}
export async function handleCriticalSignOut ({ userId, merchantId }: CriticalSignOutArgs): Promise<void> {
  gtmTrackUserLogout({ userId: String(userId) })
  Sentry.captureMessage(`User with ID: ${userId} could not find primary merchant with ID: ${merchantId}`)
  Sentry.setUser(null)
  await apiExecuteSignOut()
  clearAuthToken()
  window.location.href = '/'
}
